import { ActionConstants as LoadingActions } from '../actions';
import { checkProps } from '../../pending-promises/reducers';

const filterArray = (arrToFilter, arrToRemove) => {
  const toFilter = arrToFilter || [];
  const toRemove = arrToRemove || [];

  if (!toFilter.length || !toRemove.length) {
    return toFilter;
  }

  const newArr = toFilter.filter(arrItem =>
    toRemove.some(removeItem => {
      const removeItemType = typeof removeItem;
      if (removeItemType !== typeof arrItem) {
        return true;
      }
      if (removeItemType === 'string') {
        return removeItem !== arrItem;
      }
      if (removeItemType === 'object') {
        // if the item matches, return false to remove it
        return !checkProps(arrItem, removeItem);
      }
      return true;
    })
  );
  return newArr;
};

const mergeArrays = (arr1, arr2) => {
  const array1 = arr1 || [];
  const array2 = arr2 || [];
  return array1.concat(array2);
};

// start with state, for each prop in update data,
// update the array in state using the given data and function
// if the resulting array has data, add it to the new state object
const updateState = (state, dataForUpdate, updateArray) =>
  Object.getOwnPropertyNames(dataForUpdate)
    .map(prop => ({
      prop,
      arr: updateArray(state[prop], dataForUpdate[prop]),
    }))
    .reduce(
      (acc, curr) =>
        (curr.arr.length ? { ...acc, [curr.prop]: curr.arr } : acc),
      {}
    );

export default (state = {}, action = {}) => {
  // create a default structure for payload data in case either array is not provided
  const payloadData = action.payload && {
    includePromises: action.payload.includePromises || [],
    excludePromises: action.payload.excludePromises || [],
  };
  switch (action.type) {
    case LoadingActions.ADD_ACTIONS: {
      return updateState(state, payloadData, mergeArrays);
    }

    case LoadingActions.REMOVE_ACTIONS: {
      return updateState(state, payloadData, filterArray);
    }

    case LoadingActions.CLEAR_ACTIONS:
      return {};

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux-modules/loading-overlay/reducers/index.js